<div
  class="wc-page"
  [class.wc-page--kaufmann]="tema === 'kaufmann'"
  [class.wc-page--andes-motor]="tema === 'andes-motor'"
>
  @if (tema) {
    <h1 class="wc-page__titulo">Consentimiento {{ tema === 'kaufmann' ? 'Kaufmann' : 'Andes Motor' }}</h1>
  }

  @if (abierto && !cargando) {
    <div
      class="demo-page"
      [class.demo-page--modal]="modal"
      [class.demo-page--derecha]="posicion === 'derecha'"
      [class.demo-page--izquierda]="posicion === 'izquierda'"
    >
      @if (modal) {
        <!-- 16-sep-2026, a pedido explícito: solo el botón ✕ cierra el modal -- clickear
             afuera ya no hace nada (antes sí cerraba, ver comentario del SCSS). -->
        <div class="demo-page__backdrop"></div>
      }
      <app-consentimiento-widget
        class="demo-page__panel"
        [colorTexto]="colorTexto"
        [colorFondo]="colorFondo"
        [colorBoton]="colorBoton"
        [colorTextoBoton]="colorTextoBoton"
        [colorMasInfo]="colorMasInfo"
        [mostrarBotonCerrar]="mostrarBotonCerrar"
        [datosCliente]="datosCliente"
        [schema]="schema"
        [enviando]="enviando"
        (enviar)="onEnviar($event)"
        (cerrar)="onCerrar()"
        (click)="reiniciarTimeoutInactividad()"
        (keydown)="reiniciarTimeoutInactividad()"
      ></app-consentimiento-widget>
    </div>
  }
</div>
